import { Theme } from '@mui/material/styles';

import createStyles from '@mui/styles/createStyles';
import { isLightTheme } from 'lib/themes/theme';

export const styles = (theme: Theme) => {
  const palette = theme.palette as any;
  return createStyles({
    container: {
      marginBottom: 20,
      marginTop: 0,
    },
    tabsWrapper: {
      flexGrow: 1,
      backgroundColor: isLightTheme() ? palette.background.paper : palette.primary.background,
      display: 'flex',
    },
    tabs: {
      backgroundColor: palette.primary.grey3,
      borderRadius: theme.spacing(1),
      minWidth: theme.spacing(24),
    },
    tab: {
      textTransform: 'none',
      backgroundColor: isLightTheme() ? 'transparent' : palette.primary.background,
    },
    unselectedTab: {
      borderBottom: 1,
      borderBottomStyle: 'solid',
      borderBottomColor: isLightTheme() ? palette.primary.grey13 : palette.primary.background,
    },
    selectedTab: {
      backgroundColor: isLightTheme() ? palette.primary.grey25 : palette.primary.background,
    },
    tabContentWrapper: {
      padding: theme.spacing(2),
      // width: '100%',
    },
    invalidIcon: {
      color: palette.primary.grey23,
      fontSize: 20,
    },
    validIcon: {
      color: palette.primary.cuttySark,
      fontSize: 20,
    },
    validIconSelected: {
      color: palette.primary.patina,
    },
    labelGrid: {
      textAlign: 'left',
    },
    navigationButtonsContainer: {
      padding: 40,
    },
  });
};
